import { rankSearchHits } from './searchResultRanking.mjs';

// Reserve an article search in the same batch: orders can fill the entire
// first page before client-side ranking ever receives the matching article.
export function createArticleFirstSearchClient(client, getScope) {
    return {
        ...client,
        async search(requests) {
            if (getScope() !== 'all') return client.search(requests);
            const articleRequests = requests.map(request => ({
                ...request,
                params: {
                    ...request.params,
                    page: 0,
                    facetFilters: [...(request.params?.facetFilters || []), 'route:Articolo'],
                },
            }));
            const response = await client.search([...requests, ...articleRequests]);
            return {
                ...response,
                results: requests.map((request, index) => {
                    const result = response.results[index];
                    const articles = response.results[index + requests.length]?.hits || [];
                    const combined = [...articles, ...(result.hits || [])].filter((hit, position, hits) =>
                        hits.findIndex(other => other.route === hit.route && other.codice === hit.codice) === position);
                    return {
                        ...result,
                        hits: rankSearchHits(combined, request.params?.query).slice(0, request.params?.hitsPerPage || 20),
                    };
                }),
            };
        },
    };
}
